import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { appName } from "../../app.json";
import TextInput from "./partials/Textinput";
import DropdownInput from "./partials/DropdownInput";
import TextAreaInput from "./partials/TextAreaInput";
import { NEWSTAFFINFO, Staff } from "../../queries/staff.query";
import { useQuery, useMutation } from "react-apollo";
import auth from "../../providers/Auth.Provider";
import LoadingSpinner from "../../partials/loading";
import ImageUpload from "./partials/ImageUpload";
import { toast } from "react-toastify";
import { CleanMessage } from "../../util/app";
import { sendNotification } from "../../sockette";
import { ACTION_TYPE, EVENT_TARGET } from "../../event/model";

const NewStaff = ({ history }) => {
    const [staff, SetStaff] = useState({ gp: {}, nextKin: {} });
    const [image, setImage] = useState(null);

    const title = "New Staff Information Form";

    const { GetToken, GetAuthenticatedStaff } = auth.authProvider;
    const { site } = GetToken() && GetAuthenticatedStaff();

    // Query Get Staff Information objects to populate dropdown lists
    const { loading, data } = useQuery(NEWSTAFFINFO, {
        variables: {
            siteId: site && site.id,
            site: site && site.id,
        },
        onError: (e) => toast.error(CleanMessage(e.message)),
    });

    // Query to add new staff
    const [AddNewStaff, { loading: nLoading }] = useMutation(Staff.MUTATION.NEWSTAFF, {
        onCompleted: (data) => {
            const { message } = data.NewStaff;
            toast.success(message);
            sendNotification(message, ACTION_TYPE.CREATE, EVENT_TARGET.STAFF);
            history.push("/home/staffing/list");
        },
        onError: (e) => toast.error(CleanMessage(e.message)),
    });

    const GetAllDesignation = data && data.GetAllDesignation.docs;

    const GetDepartments = data && data.GetDepartments.docs;

    const GetAllStaffType = data && data.GetAllStaffType.docs;

    const gender = [
        {
            id: "1",
            name: "Male",
        },
        {
            id: "2",
            name: "Female",
        },
        {
            id: "3",
            name: "Others",
        },
    ];

    return (
        <>
            <Helmet>
                <title>
                    {title}| {appName}
                </title>
                <link href="../../main/formlayout.css" rel="stylesheet" type="text/css" />
            </Helmet>

            <div className="row">
                <div className="col-md-12">
                    <div className="card card-box">
                        <div className="card-body" id="bar-parent">
                            {/* Loading spinner for getting staff info objects */}

                            <form
                                className="form-horizontal"
                                onSubmit={async (e) => {
                                    e.preventDefault();
                                    await AddNewStaff({
                                        variables: {
                                            staff: { ...staff, image },
                                            siteId: site && site.id,
                                        },
                                    });
                                }}
                            >
                                <div className="form-body">
                                    <div className="col-4 bg-primary pl-5">
                                        <h5>Staff Personal Information</h5>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-4">
                                            <TextInput
                                                title="Surname"
                                                isRequired={true}
                                                placeholder="Enter surname"
                                                onValueChange={(surname) =>
                                                    SetStaff({
                                                        ...staff,
                                                        surname,
                                                    })
                                                }
                                            />
                                        </div>
                                        <div className="col-lg-4">
                                            <TextInput
                                                title="Middle Name"
                                                placeholder="Enter middle name"
                                                onValueChange={(middle_name) =>
                                                    SetStaff({
                                                        ...staff,
                                                        middle_name,
                                                    })
                                                }
                                            />
                                        </div>
                                        <div className="col-lg-4">
                                            <TextInput
                                                title="First Name"
                                                isRequired={true}
                                                placeholder="Enter last name"
                                                onValueChange={(first_name) =>
                                                    SetStaff({
                                                        ...staff,
                                                        first_name,
                                                    })
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-4">
                                            <TextInput
                                                title="Phone Number"
                                                isRequired={true}
                                                placeholder="Enter phone number"
                                                onValueChange={(mobile) =>
                                                    SetStaff({
                                                        ...staff,
                                                        mobile,
                                                    })
                                                }
                                            />
                                        </div>
                                        <div className="col-lg-4">
                                            <TextInput
                                                title="Email"
                                                type="email"
                                                isRequired={true}
                                                placeholder="Enter email"
                                                onValueChange={(email) =>
                                                    SetStaff({
                                                        ...staff,
                                                        email,
                                                    })
                                                }
                                            />
                                        </div>
                                        <div className="col-lg-4">
                                            <TextInput
                                                title="NI Number"
                                                type="text"
                                                isRequired={true}
                                                placeholder="Enter NI number"
                                                onValueChange={(nin) =>
                                                    SetStaff({
                                                        ...staff,
                                                        nin,
                                                    })
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-6">
                                            <DropdownInput
                                                title="Gender"
                                                isRequired={true}
                                                items={gender}
                                                onValueChange={(gender) =>
                                                    SetStaff({
                                                        ...staff,
                                                        gender: gender && gender.name,
                                                    })
                                                }
                                            />
                                        </div>
                                        <div className="col-lg-6">
                                            <DropdownInput
                                                title="Type"
                                                items={GetAllStaffType}
                                                onValueChange={(type) =>
                                                    SetStaff({
                                                        ...staff,
                                                        type: type.id,
                                                    })
                                                }
                                            />
                                        </div>
                                    </div>
                                    <TextAreaInput
                                        title="Contact Address"
                                        isRequired={true}
                                        placeholder="Enter contact address"
                                        onChange={(address) =>
                                            SetStaff({
                                                ...staff,
                                                address,
                                            })
                                        }
                                    />
                                    <TextInput
                                        title="Post Code"
                                        type="text"
                                        isRequired={true}
                                        placeholder="Enter post code"
                                        onValueChange={(postalCode) =>
                                            SetStaff({
                                                ...staff,
                                                postalCode,
                                            })
                                        }
                                    />
                                    <div className="row">
                                        <div className="col-lg-6">
                                            <DropdownInput
                                                title="Designation"
                                                items={GetAllDesignation}
                                                onValueChange={(designation) =>
                                                    SetStaff({
                                                        ...staff,
                                                        designation: designation.id,
                                                    })
                                                }
                                            />
                                        </div>
                                        <div className="col-lg-6">
                                            <DropdownInput
                                                title="Department"
                                                items={GetDepartments}
                                                onValueChange={(department) =>
                                                    SetStaff({
                                                        ...staff,
                                                        department: department.id,
                                                    })
                                                }
                                            />
                                        </div>
                                    </div>
                                    <TextInput
                                        title="Password"
                                        type="password"
                                        isRequired={true}
                                        placeholder="Enter password"
                                        onValueChange={(password) =>
                                            SetStaff({
                                                ...staff,
                                                password,
                                            })
                                        }
                                    />
                                    <div className="col-4 bg-primary pl-5">
                                        <h5>Next of Kin</h5>
                                    </div>

                                    <div className="row">
                                        <div className="col-lg-6">
                                            <TextInput
                                                title="Name"
                                                type="text"
                                                isRequired={true}
                                                placeholder="Enter name"
                                                onValueChange={(_name) =>
                                                    SetStaff({
                                                        ...staff,
                                                        nextKin: {
                                                            ...staff.nextKin,
                                                            name: _name,
                                                        },
                                                    })
                                                }
                                            />
                                        </div>
                                        <div className="col-lg-6">
                                            <TextInput
                                                title="Mobile"
                                                type="text"
                                                isRequired={true}
                                                placeholder="Enter mobile number"
                                                onValueChange={(_mobile) =>
                                                    SetStaff({
                                                        ...staff,
                                                        nextKin: {
                                                            ...staff.nextKin,
                                                            mobile: _mobile,
                                                        },
                                                    })
                                                }
                                            />
                                        </div>
                                    </div>

                                    <TextAreaInput
                                        title="Contact Address"
                                        isRequired={true}
                                        placeholder="Enter contact address"
                                        onChange={(_address) =>
                                            SetStaff({
                                                ...staff,
                                                nextKin: {
                                                    ...staff.nextKin,
                                                    address: _address,
                                                },
                                            })
                                        }
                                    />
                                    <div className="form-group">
                                        <label className="control-label">Relationship to Staff</label>

                                        <select
                                            onChange={(e) => {
                                                SetStaff({
                                                    ...staff,
                                                    nextKin: {
                                                        ...staff.nextKin,
                                                        relationship: e.target.value,
                                                    },
                                                });
                                            }}
                                            className="form-control input-height"
                                            required
                                        >
                                            <option value=""> - Please Select - </option>
                                            {["Brother", "Father", "Mother", "Sister", "Uncle", "Other", "Relative"].map((item) => (
                                                <option key={item} value={item}>
                                                    {item}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-4 bg-primary pl-5">
                                        <h5>GP Information</h5>
                                    </div>
                                    <div className="form-row">
                                        <div className="col">
                                            <TextInput
                                                title="Name"
                                                type="text"
                                                isRequired={true}
                                                placeholder="Enter name"
                                                onValueChange={(name) =>
                                                    SetStaff({
                                                        ...staff,
                                                        gp: {
                                                            ...staff.gp,
                                                            name,
                                                        },
                                                    })
                                                }
                                            />
                                        </div>
                                        <div className="col">
                                            <TextInput
                                                title="Phone Number"
                                                type="text"
                                                isRequired={true}
                                                placeholder="Enter Mobile"
                                                onValueChange={(mobile) =>
                                                    SetStaff({
                                                        ...staff,
                                                        gp: {
                                                            ...staff.gp,
                                                            mobile,
                                                        },
                                                    })
                                                }
                                            />
                                        </div>
                                        <div className="col">
                                            <TextInput
                                                title="Email Address"
                                                type="email"
                                                isRequired={true}
                                                placeholder="Enter Email"
                                                onValueChange={(email) =>
                                                    SetStaff({
                                                        ...staff,
                                                        gp: {
                                                            ...staff.gp,
                                                            email,
                                                        },
                                                    })
                                                }
                                            />
                                        </div>
                                    </div>
                                    <TextInput
                                        title="Post code"
                                        type="text"
                                        isRequired={true}
                                        placeholder="Enter post code"
                                        onValueChange={(post_code) =>
                                            SetStaff({
                                                ...staff,
                                                gp: {
                                                    ...staff.gp,
                                                    postCode: post_code,
                                                },
                                            })
                                        }
                                    />
                                    <TextAreaInput
                                        title="Contact Address"
                                        isRequired={true}
                                        placeholder="Enter contact address"
                                        onChange={(address) =>
                                            SetStaff({
                                                ...staff,
                                                gp: {
                                                    ...staff.gp,
                                                    address,
                                                },
                                            })
                                        }
                                    />

                                    <div className="col-4 bg-primary pl-5">
                                        <h5>Staff Profile Picture</h5>
                                    </div>
                                    <div className="row justify-content-center">
                                        <div className="col-lg-6">
                                            <ImageUpload isRequired={true} onData={(cb) => setImage(cb.path)} title="Profile Picture" />
                                        </div>
                                    </div>
                                    <LoadingSpinner loading={loading || nLoading} />
                                    <div className="text-center mt-5">
                                        <button type="submit" className="mdl-button mdl-button--raised mdl-js-ripple-effect btn-circle btn-success">
                                            Submit
                                            <i className="material-icons">arrow_right_alt</i>
                                        </button>
                                        <button
                                            onClick={() => {
                                                history.goBack();
                                            }}
                                            type="button"
                                            className="mdl-button mdl-button--raised mdl-js-ripple-effect ml-2 btn-circle btn-default"
                                        >
                                            <i className="material-icons text-danger">cancel</i>
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default NewStaff;
